import classNames from 'classnames';
import {ChangeEvent, FC, FocusEvent, KeyboardEvent, useState} from 'react';
import style from './style.module.scss';

interface IProps {
    onBlur?: (e: FocusEvent<HTMLInputElement>) => void;
    onChange: (e: ChangeEvent<HTMLInputElement>) => void;
    onKeyDown?: (e: KeyboardEvent<HTMLInputElement>) => void;
    placeholder?: string;
    value: string;
}

export const FilterInput: FC<IProps> = ({onBlur, onChange, onKeyDown, placeholder, value}) => {
    const [isFocused, setIsFocused] = useState(false);

    const handleBlur = (e: FocusEvent<HTMLInputElement>) => {
        setIsFocused(false);
        onBlur?.(e);
    };

    const handleFocus = () => {
        setIsFocused(true);
    };

    return (
        <div
            className={classNames(style.main, {
                [style.isFocused]: isFocused,
            })}
            data-skeleton-item={true}
        >
            <input
                className={style.input}
                onBlur={handleBlur}
                onChange={onChange}
                onFocus={handleFocus}
                onKeyDown={onKeyDown}
                placeholder={placeholder}
                type={'text'}
                value={value}
            />
        </div>
    );
};
